import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { motion } from "framer-motion";

export function ClarifyStage({ questions, answers, setAnswers, onSubmit, busy }) {
  const { t } = useTranslation();
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="card-crisp p-6 sm:p-8"
      data-testid="clarify-step"
    >
      <h2 className="font-display text-2xl font-bold tracking-tight">
        {t("workspace.clarifyTitle")}
      </h2>
      <p className="mt-1.5 text-sm text-muted-foreground">{t("workspace.clarifySubtitle")}</p>
      <div className="mt-6 space-y-5">
        {questions.map((q, i) => (
          <motion.div
            key={q.id}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.08 }}
            data-testid={`clarify-q-${q.id}`}
          >
            <label className="text-sm font-medium">{q.question}</label>
            {q.why && <p className="mb-1.5 text-xs text-muted-foreground">{q.why}</p>}
            <Input
              className="mt-1"
              value={answers[q.id] || ""}
              onChange={(e) => setAnswers((p) => ({ ...p, [q.id]: e.target.value }))}
              placeholder={t("workspace.answerPlaceholder")}
              data-testid={`clarify-input-${q.id}`}
            />
          </motion.div>
        ))}
      </div>
      <Button
        className="mt-6 bg-primary text-primary-foreground hover:opacity-90"
        onClick={onSubmit}
        disabled={busy === "clarify"}
        data-testid="clarify-continue-btn"
      >
        {busy === "clarify" ? t("workspace.savingBtn") : t("workspace.continueBtn")}
      </Button>
    </motion.div>
  );
}
